const SelectItemLoader = ({ count, mobile = false }) => {
	const loadersArray = Array.from({ length: count }, (v) => v);

	const loaderStyleDesktop = {
		height: '65px'
	};

	return loadersArray.map((_) =>
		mobile ? (
			<div className="d-inline-block" key={`loader_${Math.random()}`}>
				<span className="normalized-swatch mr-3 normalized-swatch-large skeleton-shimmer" />
			</div>
		) : (
			<div
				className="skeleton-shimmer mb-3"
				style={loaderStyleDesktop}
				key={`loader_${Math.random()}`}
			/>
		)
	);
};

export default SelectItemLoader;
